module.exports = __webpack_public_path__ + "static/media/chef_02.715b8789.png";